// Outline (stroke) 2x2 grid, matching the stroked admin nav icons in ./sidebar/*.
// Only consumer is the "Other" admin navigation group.
export const Grid = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="2.5"
      y="2.5"
      width="5.83333"
      height="5.83333"
      rx="1.25"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="11.6667"
      y="2.5"
      width="5.83333"
      height="5.83333"
      rx="1.25"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="2.5"
      y="11.6667"
      width="5.83333"
      height="5.83333"
      rx="1.25"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="11.6667"
      y="11.6667"
      width="5.83333"
      height="5.83333"
      rx="1.25"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default Grid
